module.exports = __webpack_public_path__ + "static/media/transfer-icon.92692452.svg";